// extracted by mini-css-extract-plugin
module.exports = {"upload_guide":"components_upload_guide__xnkNM","wrapper":"components_wrapper__oWsE_"};